import { FED_REFERENCE_NUMBER_TYPES } from 'services/search/constants';

const getFedWireValue = (id, type) => {
  if (!id) return null;
  const fedRefType = FED_REFERENCE_NUMBER_TYPES[type];
  if (!fedRefType) return id;
  return `${id} (${fedRefType})`;
};

export default getFedWireValue;



// WEBPACK FOOTER //
// ./src/components/TransferPanelWireDetails/utils/getFedWireValue.js